import utils from "../common/util";
import tableFilterHiddenRows from "../components/cmp-filter-hidden-table-rows";

/**
 * Represents the right-side panel component for interactive UI functionality.
 * Provides methods for initialization and event handling to manage interactions
 * such as opening, closing, and updating transactional state.
 *
 * @type {Object}
 * @property {HTMLElement|null} component - The main container element for the right panel.
 */
const cmpRightPanel = {
    component: null,

    init: function (element)
    {
        utils.log('cmpRightPanel initiated : #' + element.id, 'init');

        const _ = this;
        _.component = element;
        _.closeBtn = _.component.querySelector('.close-btn');
        _.triggers = document.getElementsByClassName('right-panel-trigger');
        _.assignBtns = _.component.getElementsByClassName('assign-btn');
        _.selects = _.component.querySelectorAll('select[name="service_id"]');
        _.mainPanel = document.getElementById('main-panel');

        _.onClickEvents();
    },

    onClickEvents: function ()
    {
        const _ = this;

        // allow the right panel to be opened by clicking on the trigger buttons
        for (let selector of _.triggers) {
            selector.addEventListener('click', () =>
            {
                _.component.classList.add('open');
                _.mainPanel.classList.add('right-panel-open');
            });
        }

        // allow the right panel to be closed by clicking on the close button
        _.closeBtn.addEventListener('click', () =>
        {
            _.component.classList.remove('open');
            _.mainPanel.classList.remove('right-panel-open');
        });

        // change the state of the assign button depending on whether a service has been selected
        for (let selector of _.selects) {
            selector.addEventListener('change', () =>
            {
                let btn = selector.closest('li').querySelector('.assign-btn');
                if(selector.value === '')
                {
                    btn.classList.add('disabled');
                    btn.classList.remove('success');
                    btn.setAttribute('disabled', 'disabled');
                } else {
                    btn.classList.remove('disabled');
                    btn.classList.add('success');
                    btn.removeAttribute('disabled');
                }
            });
        }

        // update the transaction upon clicking the 'submit' button
        for (let selector of _.assignBtns) {
            selector.addEventListener('click', (e) =>
            {
                e.preventDefault();
                const clickedLi = (e.target).closest('li');
                const selectedServiceId = clickedLi.querySelector('select[name="service_id"]').value;
                const transactionId = clickedLi.getAttribute('data-transaction-id');

                fetch(utils.getAppUrl() + '/transactions/' + transactionId, {
                    method: 'PATCH',
                    headers: { 'X-CSRF-TOKEN': utils.getCsrfToken(),'Accept': 'application/json', 'Content-Type': 'application/json', },
                    body: JSON.stringify({"service_id": selectedServiceId }),
                })
                    .then(response => response.json())
                    .then((data) => {
                        if(data.status === "success")
                        {
                            // let's get some variables from the transaction and the transaction table. we will need them soon enough!
                            const itemYear = clickedLi.getAttribute('data-year');
                            const itemMonth = clickedLi.getAttribute('data-month');
                            const itemValue = clickedLi.querySelector('.amount').innerText;
                            const negOrPos = clickedLi.getAttribute('data-amount') < 0 ? 'positive ' : 'negative';
                            const targetRow = document.querySelector('tr[data-service-id="' + selectedServiceId + '"]')
                            const targetCell = targetRow.querySelector('td[data-month="' + itemMonth + '"]')
                            const pageYear = targetRow.getAttribute('data-page-year');

                            // we only want to add the transaction to the page if the dragged item belongs to this current year
                            if (pageYear === itemYear) {
                                let div = document.createElement('div');
                                div.classList.add('transaction');
                                if(negOrPos === 'negative') {
                                    div.classList.add('deficit');
                                }
                                div.innerHTML = itemValue;

                                targetCell.appendChild(div);
                                targetCell.closest('tr').classList.remove('empty', 'hidden');
                                targetCell.closest('table').classList.remove('empty', 'hidden');
                            }

                            clickedLi.classList.add('removed');

                            tableFilterHiddenRows.getEmptyRows();
                        }
                    });
            });
        }
    }
}

export default cmpRightPanel;
